import { MemberAvatars } from "@components/common/member/member-avatars";
import { compareMembersByDefaultName } from "@components/table/members/members-table-utils";
import { projectMembersSelector } from "@store/projects/projects-selector";
import { useAppSelector } from "@store/store-helper";

/**
 * Shows the details regarding project members
 */
export function MemberDetails(): JSX.Element {
  const projectMembers = useAppSelector(projectMembersSelector);

  // Show the project members sorted by name
  const sortedProjectMembers = [...projectMembers].sort((a, b) =>
    compareMembersByDefaultName(a, b, "ascending")
  );

  return (
    <MemberAvatars
      label="Project Members"
      members={sortedProjectMembers}
      maxMemberAvatars={4}
    />
  );
}
